module.exports = __webpack_public_path__ + "img/35_29.f33b21a1.png";